import { useSelector } from 'react-redux';
import { selectAdAccounts } from '@mm/state/selectors/adAccountsSelecotrs';
import { useEffect, useState } from 'react';
import { AdSyncModel } from '@mm/state/model/AdModel';
import { MessengerAdController } from '@mm/state/controllers/MessengerAdController';
import { useLocation } from 'react-router-dom';

export const useSyncedMessengerAdFactory = ({
  onBusyStateChange = () => {},
  botId,
}: {
  onBusyStateChange?: (isBusy: boolean) => void;
  botId?: number;
} = {}) => {
  const adAccounts = useSelector(selectAdAccounts);
  const [syncAds, setSyncAds] = useState<AdSyncModel[]>([]);
  const location = useLocation();

  const account = adAccounts[0];
  const hide = false;
  const appropriateLocation =
    location.search.includes('ctm_ads') ||
    location.search.includes('sponsored_messages') ||
    location.search.includes('legacy_messenger_ads');

  useEffect(() => {
    (async () => {
      if (adAccounts.length === 0 || hide || !appropriateLocation) {
        return;
      }
      onBusyStateChange(true);
      const syncAdsResponse = await MessengerAdController.availableAds({
        botId,
        accountId: account.id,
        limit: 10,
      });
      setSyncAds(syncAdsResponse.data || []);
      onBusyStateChange(false);
    })();
  }, [adAccounts.length, hide]);

  const ad = syncAds[0];

  return () => ({
    adAccountId: account?.id,
    adAccountName: account?.name,
    differentUser: account?.differentUser,
    adCampaignId: ad?.campaignId || null,
    adCampaignName: ad?.campaignName || null,
  });
};
